import { environment } from '../../environments/environment';

const parseJson = (jsonString: string): Record<any, any> | null => {
    try {
        return JSON.parse(jsonString);
    } catch {
        return null;
    }
};

export const extractErrorMessage = (error: Error | any): string => {
    return error instanceof Error ? error.message : JSON.stringify(error);
};

/**
 * Checks if the current environment is internal (Vanguard internal network)
 * @returns true if the environment is internal, false otherwise
 */
export const isInternalEnvironment = (): boolean => {
    return environment.isInternal;
};

export default {
    parseJson,
    extractErrorMessage,
    isInternalEnvironment,
};
